import classNames from "classnames";
import { useContext, useMemo, useState } from "react";
import { ObjectSchema, mixed, number, object, string } from "yup";
import {
  BlankMediaListFilter,
  BlankMediaPublicInfo,
} from "../../../generated/data-contracts";
import { BlankMediaViewType, FilterType } from "../../../models";
import { IAxiosError, TableUtils, api } from "../../../utils";
import { AvisForm } from "../../shared/components";
import { AvisDescriptiveText } from "../../shared/components/form";
import {
  AvisFilterableTable,
  IColumnConfig,
} from "../../shared/components/table";
import { AvisContext } from "../../shared/context/AvisContext";
import { BlankMediaInfoFilterForm } from "../components/filters/BlankMediaInfoFilterForm";

interface IPublicBlankMediaViewProps {
  viewType: BlankMediaViewType;
  textToDisplay: string;
  titleKey: string;
}
export function PublicBlankMediaView(
  props: Readonly<IPublicBlankMediaViewProps>,
) {
  const { viewType, textToDisplay, titleKey } = props;
  const { res } = useContext(AvisContext);

  const [error, setError] = useState<IAxiosError>();
  const defaultFilterValues: BlankMediaListFilter = {
    personNameOrTaxpayerCode: "",
    personNameOrTaxpayerCodeFilterType: "Contains",
    pageIndex: 0,
    pageSize: 10,
  };

  const validationSchema: ObjectSchema<BlankMediaListFilter> = object({
    personNameOrTaxpayerCode: string(),
    personNameOrTaxpayerCodeFilterType: mixed<FilterType>(),
    pageIndex: number().min(0),
    pageSize: number().min(1),
  });

  const columnMetadata: IColumnConfig[] = useMemo(() => {
    return [
      TableUtils.columnConfigStringHTMLEnabled<BlankMediaPublicInfo>(
        "code",
        res("public_BlankMedia_label_NMRCode"),
      ),
      TableUtils.columnConfigStringHTMLEnabled<BlankMediaPublicInfo>(
        "name",
        res("label_Title"),
      ),
      TableUtils.columnConfigStringHTMLEnabled<BlankMediaPublicInfo>(
        "addressText",
        res("public_BlankMedia_label_LegalAddress"),
      ),
    ];
  }, [res]);
  const renderContent = (
    <>
      <AvisDescriptiveText textKey={textToDisplay} />
      <AvisFilterableTable<BlankMediaPublicInfo, BlankMediaListFilter>
        defaultFilterValues={defaultFilterValues}
        filterValidationSchema={validationSchema}
        setError={setError}
        getApiData={(filter) => {
          switch (viewType) {
            case BlankMediaViewType.Importer:
              return api.publicGetBlankMediaImporters(filter as any);
            case BlankMediaViewType.Manufacturer:
              return api.publicGetBlankMediaManufacturers(filter as any);
            case BlankMediaViewType.ProfessionalUser:
              return api.publicGetBlankMediaProfessionalUsers(filter as any);
          }
        }}
        renderFilter={(bag, loading, filtered) => (
          <BlankMediaInfoFilterForm
            bag={bag}
            loading={loading}
            filtered={filtered}
          />
        )}
        tableColumns={columnMetadata}
        tableColumnWidths={[15, 20, 65]}
      />
    </>
  );

  const classNameForm = classNames(
    "avis-public-container",
    "public-blank-media",
  );

  return (
    <AvisForm title={res(titleKey)} error={error} className={classNameForm}>
      {renderContent}
    </AvisForm>
  );
}
